<template>
  <div class="header"
       :class="{unfixed:!isFixed && !isMobile,fixed:isFixed && !isMobile, fixedxs:isMobile, english:lang=='EN',russian:lang=='RU',height100:isOpenXsMenu && isMobile}"
       @mouseleave="changeTab('')">
    <div class="hidden-xs">
      <div class="header-nav">
        <div class="header-navbar" ref="navbar">
          <div class="algo-div" @click="clickTab('Home')">
            <img class="logo img-fluid" src="../../assets/img/logo_white_zh.png"
                 v-if="lang =='CN'">
            <img class="logo img-fluid" src="../../assets/img/logo_white_en.png"
                 v-if="lang =='EN'" style="margin-right:3.25rem">
            <img class="logo img-fluid" src="../../assets/img/logo_white_en.png"
                 v-if="lang =='RU'" style="margin-right:3.25rem">
          </div>
          <div class="navmenu">
            <span
              @click="clickTab('Home')"
              @mouseover="changeTab('Home')"
              :class="{active:curTab=='Home' || oneTab == 'Home'}"
            >{{ $t('header.home') }}</span>

            <span
              @click="clickTab('News')"
              @mouseover="changeTab('News')"
              :class="{active:curTab=='News' || oneTab == 'News'}"
            >{{ $t('header.news') }}</span>
            <span
              @mouseover="changeTab('Solution')"
              :class="{active:curTab=='Solution' ,'actived':oneTab == 'Solution'}"
            >
                {{ $t('header.solution') }}
                <div class="drop-btn"></div>
              </span>
            <span
              @click="clickTab('AboutUs')"
              @mouseover="changeTab('AboutUs')"
              :class="{active:curTab=='AboutUs' || oneTab == 'AboutUs'}"
            >{{ $t('header.aboutUs') }}</span>
            <span
              @click="clickTab('ContactUs')"
              @mouseover="changeTab('ContactUs')"
              :class="{active:curTab=='ContactUs' || oneTab=='ContactUs'}"
            >{{ $t('header.contactUs') }}</span>
          </div>
          <div class="language pcLanguage" @click="showLanguage" style="opacity:1">
            <span @click="setLanguage('CN')" :class="{'active': lang=='CN'}">CN</span>|<span
            @click="setLanguage('EN')" :class="{'active':lang=='EN'}">EN</span>|<span @click="setLanguage('RU')"
                                                                                           :class="{'active':lang=='RU'}">RU</span>
          </div>
        </div>
      </div>
      <div id="dropMenu" style="display: none;">
        <div class="drop-menu">
          <!--          <div class="product-menu" v-if="curTab == 'Product'">-->
          <!--            <span CLASS="product-logo">PRODUCTS</span>-->
          <!--            <div class="line"></div>-->
          <!--            <div class="menu-item" v-for="item in productMenu"-->
          <!--                 @mouseenter="mouseEnterProduct(item)"-->
          <!--                 @mouseleave="mouseLeaveProduct(item)"-->
          <!--                 @click="clickProductItem(item.id)"-->
          <!--                 :class="{'menu-item-actived':item.img == item.imgActivePath || twoTab == item.id}"-->
          <!--                 :key="item.id">-->
          <!--              <img :src="twoTab == item.id?item.imgActivePath:item.img" style="width:auto;">-->
          <!--              <span>{{ $t(item.title) }}</span>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="solution-menu" v-if="curTab == 'Solution'">
            <span CLASS="product-logo">SOLUTIONS</span>
            <div class="line"></div>
            <div class="menu-item" v-for="item in solutionMenu.slice(0,5)"
                 @mouseenter="mouseEnterSolution(item)"
                 @mouseleave="mouseLeaveSolution(item)"
                 @click="clickSolutionItem(item.id)"
                 :class="{'menu-item-actived':item.img == item.imgActivePath || twoTab == item.id}"
                 :key="item.id">
              <img :src="twoTab == item.id?item.imgActivePath:item.img">
              <span>{{ $t(item.title) }}</span>
            </div>
            <!--            todo::待删除-->
            <div class="menu-item-disabled" v-for="item in solutionMenu.slice(5)" :key="item">
              <img :src="item.img">
              <span>{{ $t(item.title) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="visible-xs">
      <div class="header-nav">
        <div class="header-navbar" ref="navbar">
          <span @click.stop="clickTab('Home')">
            <img class="logo img-fluid" src="../../assets/img/logo_white_zh.png"
                 v-if="lang =='CN'">
            <img class="logo img-fluid" src="../../assets/img/logo_white_en.png"
                 v-if="lang =='EN'">
            <img class="logo img-fluid" src="../../assets/img/logo_white_en.png"
                 v-if="lang =='RU'">
          </span>
          <div class="title" id="mobileTitle">{{ $t('companyName') }}</div>
          <button type="button" class="navbar-toggle" :class="{'active':isOpenXsMenu}" id="nav-btn"
                  @click="showDropMenuXs">
            <span class="icon-bar bar-1"></span>
            <span class="icon-bar bar-2"></span>
            <span class="icon-bar bar-3"></span>
          </button>
        </div>
      </div>
      <div id="drop-menu-xs" class="drop-menu-xs">
        <ul class="content-xs">
          <el-menu
            :default-active="twoTab || curTab || oneTab"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="#babbbd"
            text-color="#fff"
            active-text-color="#2D8FFF"
            style="border: 0;"
          >
            <el-menu-item index="Home" @click="clickTab('Home')">
              <span slot="title">{{ $t('header.home') }}</span>
            </el-menu-item>
            <!--            <el-menu-item index="CoreTechnology" @click="clickTab('CoreTechnology')">-->
            <!--              <span slot="title">{{ $t('header.coreTechnology') }}</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-submenu index="Product">-->
            <!--              <template slot="title">-->
            <!--                <span>{{ $t('header.product') }}</span>-->
            <!--              </template>-->
            <!--              <el-menu-item v-for="item in productMenu"-->
            <!--                            @click="clickProductItem(item.id)"-->
            <!--                            :key="item.id"-->
            <!--                            :index="item.id">-->
            <!--                {{ $t(item.title) }}-->
            <!--              </el-menu-item>-->
            <!--            </el-submenu>-->
            <el-menu-item index="News" @click="clickTab('News')">
              <span slot="title">{{ $t('header.news') }}</span>
            </el-menu-item>
            <el-submenu index="Solution">
              <template slot="title">
                <span>{{ $t('header.solution') }}</span>
              </template>
              <el-menu-item v-for="item in solutionMenu.slice(0,5)"
                            @click="clickSolutionItem(item.id)"
                            :key="item.id"
                            :index="item.id">
                {{ $t(item.title) }}
              </el-menu-item>
              <el-menu-item v-for="item in solutionMenu.slice(5)" disabled
                            :key="item.id"
                            :index="item.id">
                {{ $t(item.title) }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="AboutUs" @click="clickTab('AboutUs')">
              <span slot="title">{{ $t('header.aboutUs') }}</span>
            </el-menu-item>
            <el-menu-item index="ContactUs" @click="clickTab('ContactUs')">
              <span slot="title">{{ $t('header.contactUs') }}</span>
            </el-menu-item>
          </el-menu>
          <div class="language">
            <span :class="{active:lang == 'CN'}" @click.stop="setLanguage('CN')">CN</span>
            <span> | </span>
            <span :class="{active:lang == 'EN'}" @click.stop="setLanguage('EN')">EN</span>
            <span> | </span>
            <span :class="{active:lang == 'RU'}" @click.stop="setLanguage('RU')">RU</span>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'element-ui/lib/theme-chalk/index.css'

export default {
  name: 'Header',
  components: {},
  props: {},
  data () {
    return {
      curHeight: 0,//记录当前位置
      curTab: '',
      isFixed: false,
      // language: 'CN',
      isOpenXsMenu: false,
      solutionMenu: [
        {
          id: 'airPort',
          title: 'header.solutionMenu.airport',
          img: require('../../assets/img/mainpage/airport.png'),
          imgPath: require('../../assets/img/mainpage/airport.png'),
          imgActivePath: require('../../assets/img/mainpage/airport2.png')
        },

        // {
        //   id: 'park',
        //   title: 'header.solutionMenu.campus',
        //   img: require('../../assets/img/mainpage/campus.png'),
        //   imgPath: require('../../assets/img/mainpage/campus.png'),
        //   imgActivePath: require('../../assets/img/mainpage/campus2.png')
        // },
        // {
        //   id: 'detection',
        //   title: 'header.solutionMenu.search',
        //   img: require('../../assets/img/mainpage/search.png'),
        //   imgPath: require('../../assets/img/mainpage/search.png'),
        //   imgActivePath: require('../../assets/img/mainpage/search2.png')
        // },
        {
          id: 'traffic',
          title: 'header.solutionMenu.traffic',
          img: require('../../assets/img/mainpage/001huoche-1-01.png'),
          imgPath: require('../../assets/img/mainpage/001huoche-1-01.png'),
          imgActivePath: require('../../assets/img/mainpage/001huoche-1-03.png')
        },
        {
          id: 'port',
          title: 'header.solutionMenu.port',
          img: require('../../assets/img/mainpage/port.png'),
          imgPath: require('../../assets/img/mainpage/port.png'),
          imgActivePath: require('../../assets/img/mainpage/port2.png')
        },
        {
          id: 'education',
          title: 'header.solutionMenu.education',
          img: require('../../assets/img/mainpage/education.png'),
          imgPath: require('../../assets/img/mainpage/education.png'),
          imgActivePath: require('../../assets/img/mainpage/education2.png')
        },
      ],
      // productMenu: [
      //   {
      //     id: 'smartRobot',
      //     title: 'header.productMenu.robot',
      //     img: require('../../assets/img/mainpage/robot.png'),
      //     imgPath: require('../../assets/img/mainpage/robot.png'),
      //     imgActivePath: require('../../assets/img/mainpage/robot_active.png')
      //   },
      //   {
      //     id: 'smartCar',
      //     title: 'header.productMenu.car',
      //     img: require('../../assets/img/mainpage/car.png'),
      //     imgPath: require('../../assets/img/mainpage/car.png'),
      //     imgActivePath: require('../../assets/img/mainpage/car_active.png')
      //   },
      //   {
      //     id: 'smartTerminal',
      //     title: 'header.productMenu.terminal',
      //     img: require('../../assets/img/mainpage/Terminal.png'),
      //     imgPath: require('../../assets/img/mainpage/Terminal.png'),
      //     imgActivePath: require('../../assets/img/mainpage/Terminal_active.png')
      //   },
      //   {
      //     id: 'smartChip',
      //     title: 'header.productMenu.chip',
      //     img: require('../../assets/img/mainpage/chip.png'),
      //     imgPath: require('../../assets/img/mainpage/chip.png'),
      //     imgActivePath: require('../../assets/img/mainpage/chip_active.png')
      //   },
      //
      //
      // ]
    }
  },
  methods: {
    changeLanguage () {
      $('#dropLanguage').show()
    },
    changeTab (tab) {
      //语言选择收起
      $('#dropLanguage').hide()
      //
      if (this.curTab == tab) {
        return
      }
      this.curTab = tab
      if (tab === 'Product' || tab === 'Solution') {
        $('#dropMenu').hide()
        $('#dropMenu').slideDown(300)
      } else {
        $('#dropMenu').slideUp(300)
      }
    },
    clickTab (tab) {

      console.log(tab)
      if (tab == '') {
      } else {
        this.curTab = tab
        this.$store.commit('setTabInfo', {
          one: tab,
          two: ''
        })
      }
      if (tab === 'Home') {
        this.$router.push('/')
      } else {
        this.$router.push({
          name: tab
        })
      }
    },
    clickSolutionItem (id) {
      // 设置当前的tab
      this.$store.commit('setTabInfo', {
        one: 'Solution',
        two: id
      })
      this.$router.push({
        name: id
      })
      // 缩起
      $('html,body').animate({
        scrollTop: 0
      }, 300)
      this.isOpenXsMenu = false
      $('body').removeClass('overflowHidden')
      $('#drop-menu-xs').slideUp(0)
      $('#dropMenu').slideUp(300)
    },
    clickProductItem (id) {
      // 设置当前的tab
      this.$store.commit('setTabInfo', {
        one: 'Product',
        two: id
      })
      this.$router.push({
        name: id
      })
      // 缩起
      $('html,body').animate({
        scrollTop: 0
      }, 300)
      this.isOpenXsMenu = false
      $('body').removeClass('overflowHidden')
      $('#drop-menu-xs').slideUp(0)
      $('#dropMenu').slideUp(300)
    },
    // mouseEnterProduct(item) {
    //   item.img = item.imgActivePath
    // },
    // mouseLeaveProduct(item) {
    //   item.img = item.imgPath
    // },
    mouseEnterSolution (item) {
      item.img = item.imgActivePath
    },
    mouseLeaveSolution (item) {
      item.img = item.imgPath
    },
    setHeaderFixed (boolean) {
      this.isFixed = boolean
    },
    getHeaderHight () {
      return this.$refs.navbar.offsetHeight
    },
    showDropMenuXs () {
      if (this.isOpenXsMenu) {
        this.isOpenXsMenu = false
        $('body').removeClass('overflowHidden')
        // 处理视频兼容性
        window.eventBus.$emit('videoHide', true)
        window.eventBus.$emit('coretecVideoHide', true)
        //  console.log(this.curHeight,'修改之后高度');
        $(window).scrollTop(this.curHeight)
        $('#drop-menu-xs').hide()
      } else {
        this.curHeight = $(window).scrollTop()
        this.isOpenXsMenu = true
        $('body').addClass('overflowHidden')
        window.eventBus.$emit('videoHide', false)
        window.eventBus.$emit('coretecVideoHide', false)
        // console.log(this.curHeight,'当前高度');
        $('#drop-menu-xs').show()
      }
      // if(this.curTab=="")

      // $('#drop-menu-xs').slideToggle(300);
    },
    handleOpen () {

    },
    handleClose () {

    },
    showLanguage () {
      $('#dropLanguage').toggle()
    },
    hideLanguage () {
    },
    setLanguage (lang) {
      // this.language = lang
      this.$i18n.locale = lang
      this.$store.dispatch('setLang', lang)
      console.log(this.$store.state.lang)
      let query = JSON.parse(JSON.stringify(this.$route.query))
      query.lang = lang
      // 给路由追加参数
      this.$router.push({
        query: query
      })
      // 弹框状态改变
      this.isOpenXsMenu = false
      window.eventBus.$emit('videoHide', true)
      window.eventBus.$emit('coretecVideoHide', true)
      $('body').removeClass('overflowHidden')
      $('#drop-menu-xs').slideUp(100)
      $('#dropLanguage').hide()
      if (this.$store.state.lang == 'CN') {
        $(document).attr('title', '全线通：走丝绸之路,创美好明天')
      } else if (this.$store.state.lang == 'EN') {
        $(document).attr('title', 'QUANXIANTONG INTERNATIONAL: Take the Silk Road and Create a Better Tomorrow ')
      } else {
        //TODO 俄文标题
        $(document).attr('title', 'QUANXIANTONG INTERNATIONAL: Идем по Шелковому пути, чтобы создать лучшее завтра ')
      }
      this.changeTitle()
    },
    // 设置移动端标题显示
    changeTitle () {
      var path = (this.$route.path + '').split('/')[1]
      if (this.$store.state.lang == 'CN') {
        if (path == '' || path == 'Home') {
          $('#mobileTitle').html('首页')
        } else if (path == 'CoreTechnology') {
          $('#mobileTitle').html('核心技术')
        } else if (path == 'Product') {
          $('#mobileTitle').html('公司产品')
        } else if (path == 'News') {
          $('#mobileTitle').html('公司新闻')
        } else if (path == 'Solution') {
          $('#mobileTitle').html('解决方案')
        } else if (path == 'AboutUs') {
          $('#mobileTitle').html('关于我们')
        } else if (path == 'AboutUs') {
          $('#mobileTitle').html('关于我们')
        } else if (path == 'ContactUs') {
          $('#mobileTitle').html('联系我们')
        }
      } else if(this.$store.state.lang == 'EN'){
        if (path == '' || path == 'Home') {
          $('#mobileTitle').html('Home')
        } else if (path == 'CoreTechnology') {
          $('#mobileTitle').html('Core Technologies')
        } else if (path == 'Product') {
          $('#mobileTitle').html('Products')
        } else if (path == 'News') {
          $('#mobileTitle').html('News')
        } else if (path == 'Solution') {
          $('#mobileTitle').html('Solutions')
        } else if (path == 'AboutUs') {
          $('#mobileTitle').html('About Us')
        } else if (path == 'ContactUs') {
          $('#mobileTitle').html('Contact Us')
        }
      } else{
        if (path == '' || path == 'Home') {
          $('#mobileTitle').html('Главная')
        } else if (path == 'CoreTechnology') {
          $('#mobileTitle').html('Core Technologies')
        } else if (path == 'Product') {
          $('#mobileTitle').html('Products')
        } else if (path == 'News') {
          $('#mobileTitle').html('Hовости')
        } else if (path == 'Solution') {
          $('#mobileTitle').html('решение')
        } else if (path == 'AboutUs') {
          $('#mobileTitle').html('о нас')
        } else if (path == 'ContactUs') {
          $('#mobileTitle').html('соединять')
        }
      }
    }
  },
  mounted () {
    // 初始化header-tab选中状态
    let one = ''
    let two = ''
    if (this.$route.path.indexOf('Solution') != -1) {
      one = 'Solution'
      two = this.$route.name
    } else {
      one = this.$route.name
      two = ''
    }
    this.$store.commit('setTabInfo', {
      one: one,
      two: two
    })
    // 初始化设置标题
    this.changeTitle()
  },
  computed: {
    ...mapGetters([
      'oneTab',
      'twoTab',
      'isMobile',
      'lang'
    ]),
    getComponentName () {
      return 'Header'
    }
  },
  watch: {
    lang () {
      this.changeTitle()
    },
    '$i18n.locale' () {
    }
  },
  beforeDestroy () {
    this.isOpenXsMenu = false
    $('body').removeClass('overflowHidden')
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  z-index: 3000;
  letter-spacing: 0.1rem;
  height: 9.75rem;
  max-height: 30rem;

  .header-nav {
    width: 100%;
    height: 5.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: center;
    z-index: 1001;
    position: absolute;

    .header-navbar {
      width: 100%;
      height: 5.25rem;
      max-width: 78rem;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .algo-div {
        cursor: pointer;

        .logo {
          width: 16rem;
          //width: auto;
          height: 4.5rem;
          cursor: pointer;
          margin-right: 2rem;
        }
      }

      .navmenu {
        width: 100%;
        /*max-width: 49.5rem;*/
        max-width: 60rem;
        // display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        span {
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 4.38rem;
          margin-right: 3.13rem;

          &:last-child {
            margin-right: 0;
          }
        }

        .active {
          color: #2D8FFF;

          .drop-btn {
            width: 0;
            height: 0;
            border-left: 0.375rem solid transparent;
            border-right: 0.375rem solid transparent;
            border-top: 0.525rem solid #2B9EFF;
            border-bottom: none;
            transform: rotate(180deg);
            transition: 0.3s ease 0.1s;
          }
        }

        .actived {
          color: #2D8FFF;

          .drop-btn {
            width: 0;
            height: 0;
            border-left: 0.375rem solid transparent;
            border-right: 0.375rem solid transparent;
            border-top: 0.525rem solid #2B9EFF;
          }
        }

        .drop-btn {
          display: inline-block;
          width: 0;
          height: 0;
          border-left: 0.375rem solid transparent;
          border-right: 0.375rem solid transparent;
          border-top: 0.525rem solid #FFFFFF;
          border-bottom: none;
          transform: rotate(360deg);
          transition: 0.1s;
        }
      }

      .language {
        width: 50rem;
        font-size: 1rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 4.38rem;
        text-align: center;
        cursor: pointer;

        img {
          margin-top: -0.2rem;
          width: 1.1rem;
          height: 1.1rem;
        }

        .drop-language {
          z-index: 9999;
          position: absolute;
          margin-top: 0;
          margin-left: 0;
          width: 8.2rem;
          height: 6.2rem;
          background: #1C2436;
          margin-top: 0.2rem;
          display: none;

          p {
            height: 3.1rem;
            margin: 0;
            line-height: 3.1rem;
            cursor: pointer;

            &.active {
              color: rgb(45, 143, 255);
            }
          }
        }
      }
    }
  }

  .drop-menu {
    width: 100%;
    height: 10.5rem;
    background: #e9e9ea;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5.25rem;

    .product-menu, .solution-menu {
      width: 100%;
      max-width: 75rem;
      display: flex;
      justify-content: left;
      align-items: center;

      .product-logo {
        max-width: 18rem;
        width: 100%;
        font-size: 2.4rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: bold;
        letter-spacing: 0.525rem;
        color: #3C4C65;
      }

      .line {
        width: 2.25rem;
        height: 2.25rem;
        margin-left: 1.5rem;
        border-left: 0.1rem solid #3C4C65;
      }

      .menu-item {
        margin: 0 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #8A98B2;

        img {
          width: 3rem;
          height: 3rem;
        }

        span {
          font-size: 0.88rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          line-height: 0.825rem;
          margin-top: 0.75rem;
        }
      }

      /*todo::待删除*/
      .menu-item-disabled {
        margin: 0 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: default;
        color: #3F4A5D;

        img {
          width: 3rem;
          height: 3rem;
        }

        span {
          font-size: 0.88rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          line-height: 0.825rem;
          margin-top: 0.75rem;
        }
      }

      .menu-item-actived {
        cursor: pointer;
        color: #2B9EFF;
      }
    }
  }
}

.header:hover {
  .header-nav {
    background-color: #babbbd;
  }
}

.unfixed {
  height: 9.75rem;
  background: linear-gradient(0deg, rgba(59, 73, 98, 0) 0%, rgba(29, 38, 50, 1) 100%);
}

.fixed {
  position: fixed;
  height: 5.25rem;

  .header-nav {
    background-color: #babbbd;
    /*box-shadow: 0rem 0rem 0.1rem 0rem rgba(179, 193, 218, 0.41);*/
  }
}

.fixedxs {
  position: fixed;
  height: 3.5rem;
  max-height: 100%;

  .header-nav {
    background-color: #babbbd;
  }

  .drop-menu-xs {
    height: calc(100% - 3.5rem) !important;
    background-color: rgb(41, 48, 61);

    .content-xs {
      // max-height: calc(100% - 3.5rem) !important;
      max-height: 100%;
    }
  }
}

.height100 {
  height: 100%;
}

/*手机版样式*/
.visible-xs {

  .header-nav {
    height: 3.5rem;

    .header-navbar {
      height: 3.5rem;
      margin: 0 1rem;

      .logo {
        height: 3rem;
        width: 10.5rem;
      }

      .title {
        font-size: 1rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 3.5rem;
      }

      .btn-toggle {
        width: 2rem;
        height: 2rem;
      }

      .navbar-toggle {
        span {
          background: #FFFFFF;
          transition: all 0.3s;
          -webkit-transition: all 0.3s;
        }

        margin: 0;
        padding: 0;
      }

      .active {
        .bar-1 {
          transform: rotateZ(45deg) translateY(8px);
        }

        .bar-2 {
          opacity: 0;
        }

        .bar-3 {
          transform: rotateZ(-45deg) translateY(-8px);
        }
      }
    }
  }

  .drop-menu-xs {
    position: absolute;
    margin-top: 3.5rem;
    width: 100%;
    height: 35rem;
    display: none;
    z-index: 999999;

    .content-xs {
      width: 100%;
      height: auto;
      max-height: 100%;
      overflow-y: auto;
      padding: 0;
      z-index: 999999;
      // background: red;
    }
  }

  .language {
    padding-left: 20px;
    color: rgb(255, 255, 255);
    background-color: rgb(41, 48, 61);

    height: 56px;
    line-height: 56px;
    position: relative;
    -webkit-box-sizing: border-box;
    white-space: nowrap;
    list-style: none;
    padding: 0 20px;

    span {
      font-size: 14px;
      cursor: pointer;
      -webkit-transition: border-color .3s, background-color .3s, color .3s;
      transition: border-color .3s, background-color .3s, color .3s;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    .disabled {
      opacity: .25;
      cursor: not-allowed;
      background: 0 0 !important
    }

    .active {
      color: rgb(45, 143, 255);
    }
  }
}

/*英文版样式*/
.english,.russian{
  letter-spacing: 0.05rem;

  //.header-nav {
  //  .header-navbar {
  //    max-width: 75rem;
  //
  //    .navmenu {
  //      /*max-width:50rem;*/
  //      max-width: 60rem;
  //
  //      span {
  //        margin-right: 1.5rem;
  //
  //        &:last-child {
  //          margin-right: 0 !important;
  //        }
  //      }
  //    }
  //  }
  //}

  .solution-menu .menu-item, .solution-menu .menu-item-disabled {
    margin: 0 auto !important;
  }
}

.russian {
  .header-nav {
    .header-navbar {
      max-width: 90rem;

      .navmenu {
        /*max-width:50rem;*/
        max-width: 70rem;

        span {
          margin-right: 1.5rem;

          &:last-child {
            margin-right: 0 !important;
          }
        }
      }
    }
  }
}
// 切换语言
.pcLanguage {
  span {
    margin: 1rem 0.5rem;
  }

  span.active {
    color: rgb(45, 143, 255) !important
  }
}

@media screen and (max-width: 960px) {
  .header.fixed .header-nav .header-navbar .navmenu span {
    margin-right: 2rem !important;
  }
  .english,.russian {
    .header.fixed .header-nav .header-navbar .navmenu span {
      margin-right: 1rem !important;
    }

    .header.fixed .header-nav .header-navbar .navmenu {
      max-width: 60rem !important;
    }

    .header.fixed .header-nav .header-navbar .logo {
      margin-right: 0.5rem !important;
    }

    .header.fixed .header-nav .header-navbar .language {
      width: 16rem
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue